// Het aantal notities per huishouden, zodat het overzicht laat zien waar al
// iets over vastgelegd is zonder dat je elk huishouden hoeft te openen
// (updateverzoek BuurtKlusBedrijf, 2026-09-21).
//
// Alle notities van de organisatie in één keer, niet per rij een telling: bij
// de grootste organisatie zijn dat honderden huishoudens, en dat zouden dus
// honderden zoekopdrachten zijn.
//
// AI-CONTEXT: See docs/features/household-overview-table-and-statuses.md

/**
 * Aantal notities per huishouden.
 *
 * Zacht verwijderde notities tellen niet mee: die zijn voor de gebruiker weg,
 * en een teller die ze wél meerekent zegt dat er iets staat waar niets meer
 * staat. Dat wordt hier met de hand gedaan én in de hook — dubbel is hier
 * onschadelijk, en deze functie moet ook los kloppen.
 *
 * @param {Array<object>} [notes] - Alle AdressNotes-documenten van de organisatie
 * @returns {Record<string, number>} Huishoudens zonder notities ontbreken
 */
const notesPerAdress = (notes) => {
    const alle = Array.isArray(notes) ? notes : []

    /** @type {Record<string, number>} */
    const result = {}

    alle.forEach((note) => {
        if (note?.Deleted === true) return

        const adressId = note?.AdressID
        if (!adressId) return

        result[adressId] = (result[adressId] || 0) + 1
    })

    return result
}

export default notesPerAdress
